import * as Request from '../../request'
export const UPDATE_CREATE_COMMUNITY_FIELD = 'UPDATE_CREATE_COMMUNITY_FIELD'
export const CREATE_COMMUNITY = 'CREATE_COMMUNITY'
export const CREATE_COMMUNITY_REQUEST = `${CREATE_COMMUNITY}_${Request.REQUEST}`
export const CREATE_COMMUNITY_SUCCESS = `${CREATE_COMMUNITY}_${Request.SUCCESS}`
export const CREATE_COMMUNITY_ERROR = `${CREATE_COMMUNITY}_${Request.ERROR}`



// WEBPACK FOOTER //
// ./src/pages/create-community/constants.ts